import { render, staticRenderFns } from "./XInputImage.vue?vue&type=template&id=65d4a477"
import script from "./XInputImage.vue?vue&type=script&lang=js"
export * from "./XInputImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports